import * as yup from 'yup';

import { passwordValidationSchema } from 'src/constants/validation';

import { ResetPasswordFormFields } from '../types';

export const resetEmailFormValidationSchema = yup.object({
  [ResetPasswordFormFields.newPassword]: passwordValidationSchema.nullable().required('Required'),
  [ResetPasswordFormFields.confirmNewPassword]: passwordValidationSchema
    .test(ResetPasswordFormFields.confirmNewPassword, 'Passwords must match', (value, context) => {
      return context.parent[ResetPasswordFormFields.newPassword] === value;
    })
    .nullable()
    .required('Required'),
});
